import { z } from 'zod';

export const recordDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD')
  .refine((s) => !Number.isNaN(Date.parse(s)), 'Invalid date');

const numericString = z
  .union([z.number(), z.string().regex(/^\d+(\.\d+)?$/, 'Must be a number')])
  .transform((v) => (typeof v === 'number' ? v.toString() : v));

export const recordFormSchema = z.object({
  recordDate: recordDateSchema,
  heightCm: numericString.optional().nullable(),
  weightKg: numericString.optional().nullable(),
  categoryId: z.coerce.number().int().positive().optional().nullable(),
  notes: z.string().max(2000).optional().nullable(),
});
export type RecordFormValues = z.infer<typeof recordFormSchema>;

export const categoryFormSchema = z.object({
  name: z.string().min(1).max(40).trim(),
  color: z
    .string()
    .regex(/^#?[0-9a-fA-F]{6}$/, 'Color must be a hex like #RRGGBB')
    .optional()
    .or(z.literal('')),
  icon: z.string().max(40).optional(),
});
export type CategoryFormValues = z.infer<typeof categoryFormSchema>;

export const profileFormSchema = z
  .object({
    displayName: z.string().min(1).max(80).trim(),
    locale: z.enum(['tr', 'en']),
    theme: z.enum(['light', 'dark', 'system']),
    units: z.enum(['metric', 'imperial']),
  })
  .strict();
export type ProfileFormValues = z.infer<typeof profileFormSchema>;

export const passwordFormSchema = z
  .object({
    currentPassword: z.string().min(1).max(128),
    newPassword: z
      .string()
      .min(8, 'Password must be at least 8 characters')
      .max(128)
      .regex(/[A-Za-z]/, 'Password must contain at least one letter')
      .regex(/[0-9]/, 'Password must contain at least one digit'),
    confirmPassword: z.string().min(1).max(128),
  })
  .refine((d) => d.newPassword === d.confirmPassword, {
    path: ['confirmPassword'],
    message: 'Passwords do not match',
  });
export type PasswordFormValues = z.infer<typeof passwordFormSchema>;
